import { ADICIONAR_FILTRO_PONTO_EMBARQUE } from '../types'

export default function adicionarFiltroPontoEmbarque (filtro) {
  return {
    type: ADICIONAR_FILTRO_PONTO_EMBARQUE,
    payload: filtro
  }
}
